import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import LandluxTyres from "./pages/LandluxTyres";
import Wholesale from "./pages/Wholesale";
import Contact from "./pages/Contact";
import GetQuote from "./pages/GetQuote";
import GlobalStyles from "./styles/GlobalStyles";

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <GlobalStyles />
        <Header />
        <MainContent>
          <Routes>
            <Route
              path="/"
              element={<Home />}
            />
            <Route
              path="/about"
              element={<About />}
            />
            <Route
              path="/services"
              element={<Services />}
            />
            {/* Vikrant tyre page removed — only Landlux is offered now */}
            <Route
              path="/landlux-tyres"
              element={<LandluxTyres />}
            />
            <Route
              path="/wholesale"
              element={<Wholesale />}
            />
            {/* Trailer Repair route removed - service not offered */}
            <Route
              path="/contact"
              element={<Contact />}
            />
            <Route
              path="/get-quote"
              element={<GetQuote />}
            />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
